const rankingItems = [
  { rank: 1, title: '锦绣芳华', type: '古装传奇', heat: '99.8', trend: 'up', desc: '大女主成长史诗，服化道惊艳' },
  { rank: 2, title: '暗夜追凶', type: '悬疑犯罪', heat: '97.2', trend: 'up', desc: '12集高能反转，豆瓣8.9分' },
  { rank: 3, title: '星际迷航：新纪元', type: '科幻冒险', heat: '94.5', trend: 'same', desc: '视效炸裂，年度科幻巨制' },
  { rank: 4, title: '温柔的谎言', type: '都市情感', heat: '91.3', trend: 'up', desc: '收视率破2，全网热议' },
  { rank: 5, title: '山海异闻录', type: '奇幻仙侠', heat: '88.7', trend: 'down', desc: '特效升级，世界观宏大' },
  { rank: 6, title: '青春纪念册', type: '校园青春', heat: '85.1', trend: 'new', desc: '新人演员惊艳，口碑逆袭' },
  { rank: 7, title: '大唐秘史', type: '历史权谋', heat: '82.4', trend: 'up', desc: '老戏骨飙戏，年度必看' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热播排行榜
          </h2>
          <p className="text-sm text-foreground-600">本周最受追剧党欢迎的电视剧</p>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-5 px-4 md:px-6 py-3.5 border-b border-background-200/40 last:border-b-0 hover:bg-primary-50/30 transition-colors cursor-pointer"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">{item.type}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 hidden sm:block">{item.desc}</p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="flex items-center gap-1 text-xs text-foreground-600">
                  {item.trend === 'up' ? (
                    <i className="ri-arrow-up-fill text-primary-500"></i>
                  ) : item.trend === 'down' ? (
                    <i className="ri-arrow-down-fill text-foreground-400"></i>
                  ) : item.trend === 'new' ? (
                    <i className="ri-sparkling-2-fill text-accent-500"></i>
                  ) : (
                    <i className="ri-subtract-line text-foreground-400"></i>
                  )}
                </span>
                <span className="text-sm font-bold text-primary-600 whitespace-nowrap">{item.heat}<span className="text-xs font-normal text-foreground-500 ml-0.5">万热度</span></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}